var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isScheduled,
          expression: "isScheduled",
        },
      ],
      staticClass: "item textual_menu--item no-image",
      class: _vm.containerClasses,
      attrs: { id: "textual_menu--item-" + _vm.item.mi_id },
    },
    [
      _c("h3", [
        _c("a", {
          staticClass:
            "item_button--container item_button--container-select material-icons",
          class: {
            "item_button--container-active":
              -1 !==
              _vm.$store.state.selectedMenuItemIds.indexOf(_vm.item.mi_id),
          },
          attrs: {
            href: "#",
            title:
              -1 !==
              _vm.$store.state.selectedMenuItemIds.indexOf(_vm.item.mi_id)
                ? "Click to remove this item from saved list"
                : "Click to save this item for later",
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$store.commit("toggleMenuItemSelected", [
                _vm.item.mi_id,
                _vm.menu.menu_id,
              ])
            },
          },
        }),
        _vm._v(" "),
        _vm.isBinShown
          ? _c("span", [
              _c("span", { staticClass: "menu_item--bin" }, [
                _vm._v(_vm._s(_vm.bin)),
              ]),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.getTitleWithoutBin(_vm.item)),
                },
              }),
            ])
          : _c("span", { domProps: { innerHTML: _vm._s(_vm.item.mi_title) } }),
        _vm._v(" "),
        _vm.item.mi_market_price > 0
          ? _c("div", { staticClass: "menu_item--price" }, [_vm._v("MP")])
          : _vm.item.mi_price.length && !_vm.isPricingTypesShown
          ? _c("div", {
              staticClass: "menu_item--price",
              domProps: { innerHTML: _vm._s(_vm.item.mi_price) },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isPricingTypesShown
        ? _c(
            "ul",
            { staticClass: "menu_item--prices" },
            _vm._l(_vm.pricingTypes, function (pricingType) {
              return _c(
                "li",
                { key: pricingType[0], staticClass: "menu_item--price" },
                [_vm._v(_vm._s(pricingType[0]) + " " + _vm._s(pricingType[1]))]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isTagsShown
        ? _c(
            "div",
            { staticClass: "menu_item--tags" },
            _vm._l(_vm.item.tags, function (tag) {
              return _c("menu-tag", {
                key: tag.mt_id,
                attrs: { tag: tag, "menu-type": "textual" },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isBodyShown
        ? _c("div", { staticClass: "menu_item--body item-body" }, [
            _vm.item.mi_subtitle.length
              ? _c("h4", {
                  domProps: { innerHTML: _vm._s(_vm.item.mi_subtitle) },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.item.mi_description.length
              ? _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.item.mi_description) },
                })
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }